import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import "./Layout.css";
import "./AccountUI.css";

const Layout: React.FC = () => {
  const { pathname } = useLocation();
  const isAccountArea = /^\/(profile-|dashboard-admin|outras-informacoes-|mudar-senha-|colaborar-|minhas-colaboracoes-|colaboracao-|solicitacoes-|solicitacao-|contas-usuarios-)/.test(pathname);
  return (
    <div className={`app-layout${isAccountArea ? " account-area" : ""}`}>
      <div className="app-content">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
